import React from 'react';
import {useNavigate} from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <footer className="case-footer">
      <div className="footer-content">
        <div className="company-info">
            <img src="./msl_logo.png" width={140} alt="Company Logo"/>
          <h3>杭州深康明视科技有限公司</h3>
          <p>妙视力视觉训练是一款专为3-12岁弱视儿童设计的弱视训练软件，兼顾儿童对趣味体验的渴望与家长对专业效果的期待，通过多种游戏与多种动画的创新融合，让弱视训练不再枯燥。</p>
        </div>
        <div className="footer-links">
          <div className="link-column" onClick={() => handleNavigation('/')}>
            <h4>首页</h4>
          </div>
          {/*<div className="link-column" onClick={() => handleNavigation('/case')}>*/}
          {/*  <h4>成功案例</h4>*/}
          {/*</div>*/}
          <div className="link-column" onClick={() => handleNavigation('/product')}>
            <h4>产品介绍</h4>
          </div>
          <div className="link-column" onClick={() => handleNavigation('/download')}>
            <h4>下载软件</h4>
          </div>
        </div>
      </div>
      <div className="footer-divider"></div>
      <div className="copyright">
        <p>浙ICP备2025194012号-2A</p>
      </div>
    </footer>
  );
};

export default Footer;